import { EventData } from "../store/services/timelineApiRTK";


// Parsed data interfaces for different types
export interface CommentEventData {
  Description: string;
}

export interface FileAttachmentEventData {
  Type: number;
  Filename: string;
  OrginalFilename: string; // Note: keeping original typo from API
}

export interface SurveyEventData {
  SurveyId: number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Answers: any | null;
  InstanceId: number;
}

export interface EmailEventData {
  To: string;
  From: string;
  Subject: string;
  Html: string;
  Text: string;
  SpamReport: string;
  SpamScore: string;
  CcEmails: string[];
  Attachments: unknown[];
  InlineImages: unknown[];
  Deleted: boolean;
  ExternalId: string | null;
  ConversationId: string | null;
}

// Union type for all parsed event data
export type ParsedEventData = CommentEventData | FileAttachmentEventData | SurveyEventData | EmailEventData;

// Combined interface for processed EventData
export interface ProcessedEventData extends EventData {
  parsedData: ParsedEventData | null;
  displayName: string;
  icon: string;
  color: string;
}

// Type guards
export const isCommentEventData = (data: ParsedEventData): data is CommentEventData => {
  return 'Description' in data;
};

export const isFileAttachmentEventData = (data: ParsedEventData): data is FileAttachmentEventData => {
  return 'Filename' in data && 'OrginalFilename' in data;
};

export const isSurveyEventData = (data: ParsedEventData): data is SurveyEventData => {
  return 'SurveyId' in data && 'InstanceId' in data;
};

export const isEmailEventData = (data: ParsedEventData): data is EmailEventData => {
  return 'To' in data && 'From' in data && 'Subject' in data && 'Html' in data;
};